import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import "leaflet-rotatedmarker"; 

import { IDeviceCompass, IMapLocationTracker } from '../../../LocationInfo/types';
import { IMapMarkerIcon } from '../../layers';
import { mapMarkerToLeafletIcon } from '../../layerUtils';


type MapCurrentLocationMarkerProps = {
    locationTracker: IMapLocationTracker;
    deviceCompass: IDeviceCompass,
    withHeadingIconUrl: IMapMarkerIcon;
    noHeadingIconUrl: IMapMarkerIcon;
}


const MapCurrentLocationMarker = (props: MapCurrentLocationMarkerProps) => {
     
    const map = useMap();
    const marker = useRef<L.Marker>();
    const location = props.locationTracker.location;
    const headingDegrees = props.deviceCompass.headingDegrees;

    useEffect(() => {
        
        if (!location) {
            marker.current?.removeFrom(map);
            return;
        }

        if (!marker.current) {  //Lazy create
            marker.current = L.marker(location.point).addTo(map);
            (marker.current as any).setRotationOrigin("center");
        }
        else {
            marker.current.setLatLng(location.point);
        }

        if (headingDegrees != null) {
            marker.current.setIcon(mapMarkerToLeafletIcon(props.withHeadingIconUrl));
            (marker.current as any).setRotationAngle(headingDegrees);
        }
        else {
            marker.current.setIcon(mapMarkerToLeafletIcon(props.noHeadingIconUrl));
            (marker.current as any).setRotationAngle(0);
        }

    }, [map, location, headingDegrees, props.withHeadingIconUrl, props.noHeadingIconUrl]);

    return <></>;
}
 
export default MapCurrentLocationMarker;